// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__23kWb","consentsList":"PatientConsents_consentsList__2NJFW","consentsListEmpty":"PatientConsents_consentsListEmpty__12Fgh"};